class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".product-sticky-bar-cta");
    this.faq = this.querySelector("[data-faq]");
    this.details = this.querySelector("[data-detail]");
    this.reviews = this.querySelector("[data-review]");
    this.buttons = this.querySelectorAll("[data-to]");
    this.header = document.querySelector("header#header");
  }
  connectedCallback() {
    // 添加滚动事件监听
    this.setHeaderHeight();
    window.addEventListener(
      "scroll",
      this.throttle(() => {
        // 获取当前垂直滚动距离
        const currentScroll =
          window.scrollY || document.documentElement.scrollTop;
        this.anchors = document.querySelectorAll("[data-anchor]");
        this.buttons.forEach((button) => {
          const toEl = document.querySelector(
            `[data-anchor="${button.getAttribute("data-to")}"]`
          );
          const toElTop = toEl.getBoundingClientRect().top;
          const toElTopWithHeight =
            toElTop + toEl.getBoundingClientRect().height;
          if (
            toElTop < window.innerHeight / 2 &&
            toElTopWithHeight > window.innerHeight / 2
          ) {
            this.buttons.forEach((btn) => {
              btn.classList.remove("active");
            });
            button.classList.add("active");

            this.querySelector(".product-sticky-bar-quick-link").scrollTo(
              button.offsetLeft,
              0
            );
          } else {
          }
        });
      }, 500)
    );

    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        document
          .querySelector(`[data-anchor="${button.getAttribute("data-to")}"]`)
          .scrollIntoView({ behavior: "smooth" });
      });
    });
  }
  setHeaderHeight() {
    const headerHeight = this.header.offsetHeight;
    this.closest(".shopify-section").style.setProperty(
      "--header-height",
      `${headerHeight - 1}px`
    );
  }
  throttle(func, limit = 100) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}
if (!customElements.get("product-sticky-bar")) {
  customElements.define("product-sticky-bar", ProductStickyBar);
}
